import { StaffCommentSubjectInput } from '../../lib/types/models/staff-comment-subject/staff-comment-subject-input'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function createStaffCommentSubject(data: StaffCommentSubjectInput) {
  return restApiClient.url(constructApiUrl(API.staffCommentSubjects.create.url, null)).post(data)
}
